import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import AddEmployees from "../features/addEmployees";
import StepGeneralInformation from "../features/addEmployees/components/StepGeneralInformation";
import StepContract from "../features/addEmployees/components/StepContract";
import StepRole from "../features/addEmployees/components/StepRole";
import StepRessources from "../features/addEmployees/components/StepRessources";
import StepTasksAndModal from "../features/addEmployees/components/StepTasksAndModal";

/* add collaborateur with new design of fluent ! */
export const addEmployeeRoutes = (
    <Route
        path={ROUTES.employee_add}
        element={<AddEmployees />}
        key="addEmployee"
    >
        <Route index path="" element={<StepGeneralInformation />} />
        <Route path="first" element={<StepGeneralInformation />} />
        <Route path="second" element={<StepContract />} />
        <Route path="third" element={<StepRole />} />
        <Route path="fourth" element={<StepRessources />} />
        <Route path="fifth" element={<StepTasksAndModal />} />
    </Route>
);
